export function ensureHttpPrefix(url: string) {
  if (!url.match(/^https?:\/\//i)) {
    return 'http://' + url
  }
  return url
}

export function openUrl(url: string) {
  const prefixedUrl = ensureHttpPrefix(url)
  window.open(prefixedUrl, '_blank')
}
